import { FaTrash } from "react-icons/fa";
import styles from "../css/invoice.module.css";

export default function LineItems({ 
  lineItems, 
  onItemChange, 
  onDeleteItem, 
  calculateTotal 
}) {
  return (
    <div className={styles.card}>
      <h3 className={styles.sectionTitle}>Line Items</h3>

      <div className={styles.tableHeader}>
        <span>Code</span>
        <span>Description</span>
        <span>Qty</span>
        <span>Unit Price</span>
        <span>Total</span>
        <span></span>
      </div>

      {lineItems.map((item) => (
        <div key={item.id} className={styles.row}>
          <span>{item.code}</span>
          <span>{item.description}</span>

          <input
            type="number"
            value={item.quantity}
            onChange={(e) =>
              onItemChange(item.id, "quantity", parseInt(e.target.value) || 0)
            }
          />

          <input
            type="number"
            value={item.unitPrice}
            onChange={(e) =>
              onItemChange(item.id, "unitPrice", parseFloat(e.target.value) || 0)
            }
          />

          <span className={styles.totalCell}>
            R{item.total.toFixed(2)}
          </span>

          <button
            className={styles.deleteBtn}
            onClick={() => onDeleteItem(item.id)}
          >
            <FaTrash style={{ color: 'red' }} />
          </button>
        </div>
      ))}

      {/* Total */}
      <div className={styles.totalRow}>
        <span>Total</span>
        <strong>R{calculateTotal().toFixed(2)}</strong>
      </div>
    </div>
  );
}
